import { DateTime } from '@ksyos/date-time';
import { IconButton, TableCell, TableRow } from '@ksyos/design-system';
import { Link as ReactRouterLink } from '@ksyos/router';
import React from 'react';
import type { CompensationPayoutForServiceActivityUpdatableFields } from '@common/validation/compensationPayoutForServiceActivity';
import type { PayableServiceActivity } from '@common/validation/payableServiceActivity';
import { getLanguage } from '@common/translate/translate';
import { isActiveOnDateOrInTheFuture } from '@common/utils/isActiveOnDate';
import { Currency } from '@frontend/components/elements/common';

type PayableServiceActivityCompensationPayoutProps = {
    canEdit: boolean;
    payableServiceActivity: PayableServiceActivity;
    serviceCompensationPayouts: CompensationPayoutForServiceActivityUpdatableFields[];
    serviceId: string;
};
export function PayableServiceActivityCompensationPayout(props: PayableServiceActivityCompensationPayoutProps) {
    const { canEdit, serviceCompensationPayouts, payableServiceActivity, serviceId } = props;
    const translate = getLanguage();
    const isActive = isActiveOnDateOrInTheFuture(payableServiceActivity, new Date());

    return (
        <TableRow>
            <TableCell style={getStyle(!isActive, true)}>{payableServiceActivity.serviceActivity.name}</TableCell>
            <TableCell style={getStyle(!isActive)}>
                {payableServiceActivity.conditionalServiceActivity?.name ?? 'n.v.t.'}
            </TableCell>
            <TableCell style={getStyle(!isActive)}>
                <Currency
                    value={
                        serviceCompensationPayouts.find(
                            (compensationPayout) =>
                                compensationPayout.serviceActivityId === payableServiceActivity.serviceActivityId &&
                                compensationPayout.startDate === payableServiceActivity.startDate &&
                                compensationPayout.endDate === payableServiceActivity.endDate
                        )?.amount
                    }
                />
            </TableCell>
            <TableCell style={getStyle(!isActive)}>
                {DateTime.from(payableServiceActivity.startDate).format('DD-MM-YYYY')}
            </TableCell>
            <TableCell style={getStyle(!isActive)}>
                {payableServiceActivity.endDate
                    ? DateTime.from(payableServiceActivity.endDate).format('DD-MM-YYYY')
                    : '-'}
            </TableCell>
            <TableCell style={getStyle(!isActive)}>
                {translate.compensationPayoutRecipientEnum[payableServiceActivity.payoutRecipient]}
            </TableCell>
            <TableCell style={getStyle(true, false, true)}>
                {canEdit && (
                    <ReactRouterLink
                        className="icon-link"
                        to={`/services/${serviceId}/serviceCompensationPayouts/${payableServiceActivity.id}`}
                    >
                        <IconButton
                            icon="edit"
                            size="small"
                        />
                    </ReactRouterLink>
                )}
            </TableCell>
        </TableRow>
    );
    function getStyle(isDisabled: boolean, isBold?: boolean, isIcon?: boolean): React.CSSProperties {
        return {
            color: isDisabled ? 'gray' : 'neutral700',
            fontWeight: isBold ? 500 : 400,
            textAlign: isIcon ? 'right' : 'left',
        };
    }
}
